import { createContext, PropsWithChildren, useContext } from 'react';
import { LogTypeStyles } from '@features/components/ClinicalData/components/ClinicalLog/types';
import { StreamChannelType } from '@/api/apis/chat';
import { ClinicalItemType } from '@/api/apis/case';
import { EtaContent } from '@/types';

export enum AppType {
  NopConnectPlatform = 'nop-connect',
  NopAccessPlatform = 'nop-access',
  Failover = 'failover',
}

// TODO we can include CUSTOMER_ROLE_NAMES
export type AppContextProps = {
  type: AppType;
  caseDetails: { etaContent: EtaContent[] };
  clinicalLog: { names: Record<ClinicalItemType, string>; styles: LogTypeStyles };
  chartConfig: {
    barChart: {
      showMaxValueIndicator: boolean;
      showBarDiff: boolean;
    };
  };
  chatConfig: {
    excludedChannelTypesToShare: StreamChannelType[];
  };
};

const AppContext = createContext<AppContextProps | null>(null);

export const AppProvider = ({ config, children }: PropsWithChildren<{ config: AppContextProps }>) => (
  <AppContext.Provider value={config}>{children}</AppContext.Provider>
);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === null) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
